import {Component, Inject, Input, OnInit} from '@angular/core';
import {DOCUMENT} from "@angular/common";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {GetServerFromUrl} from "../../defines/common.func";
import {GlobalEventService} from "../../services/global-event/global-event.service";

let apiLoaded = false;

@Component({
  selector: 'app-youtube-player',
  template: `
    <article class="video-popup">

      <div class="popup-wrapper">

        <a class="popup-close-btn" (click)="onClose($event)"></a>

        <div class="embed-container">
          <youtube-player videoId="{{ youtubeId }}"
                          [playerVars]="{autoplay: 1, origin: location.host, rel: 0}"></youtube-player>
        </div>

      </div>

    </article>
    <p>youtube-player works!</p>
  `,
})
export class YoutubePlayerComponent implements OnInit {
  @Input() youtubeId?: string;

  protected readonly location = location;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private lm: LayoutMgrService,
    private globalEventSvc: GlobalEventService,
  ) {

  }

  ngOnInit() {
    if (!apiLoaded) {
      // This code loads the IFrame Player API code asynchronously, according to the instructions at
      // https://developers.google.com/youtube/iframe_api_reference#Getting_Started
      const tag = this.document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      this.document.body.appendChild(tag);
      apiLoaded = true;
    }
    // console.warn('YoutubePlayerComponent::ngOnInit() youtubeId =', location.origin);
  }

  onClose(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event, true);

    if (this.lm.youtubePopup$ === null) {
      throw new Error('YoutubePlayerComponent::onClose() this.lm.youtubePopup$ is null');
    }
    this.lm.youtubePopup$.next(this.lm.youtubeId);
    this.lm.youtubePopup$.complete();
  }

}
